module.exports = __webpack_public_path__ + "images/create-first-board/card-back/cardBack-en.0445f5ab7ad718582798.svg";